import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Circle = styled.span<{
  $percentage: number;
  $isSmall: boolean;
  $isSuccess?: boolean;
}>`
  position: relative;
  display: inline-block;

  width: 1.15em;
  height: 1.15em;

  border-radius: 50%;
  border: 1px solid currentColor;

  &:before {
    content: '';
    position: absolute;
    border-radius: 50%;
    inset: 0.2rem;
    background: ${({ $percentage }) =>
      $percentage >= 100
        ? 'currentColor'
        : `conic-gradient(currentColor ${$percentage}%,#0000 0)`};
  }

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      width: 1em;
      height: 1em;
    `}

  ${({ $isSuccess, theme }) =>
    $isSuccess &&
    css`
      color: ${theme.palette.success.main};
    `}
`;

export const IconCircle = styled.span<{ $isSmall: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.15em;
  height: 1.15em;

  border-radius: 50%;
  background: ${({ theme }) => theme.palette.success.main};

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      width: 1em;
      height: 1em;
    `}
`;

export const IconContainer = styled.span`
  color: ${({ theme }) => theme.palette.success.contrastText};
  font-size: 0.625em;
  line-height: 62.5%;
`;

export const Label = styled.span<{
  $isSecondary: boolean;
  $isPrimary: boolean;
  $isComplete: boolean;
  $isSuccess?: boolean;
}>`
  cursor: default;

  ${({ $isSecondary, theme }) =>
    $isSecondary &&
    css`
      color: ${theme.palette.text.secondary};
    `};

  ${({ $isPrimary, theme }) =>
    $isPrimary &&
    css`
      color: ${theme.palette.text.primary};
    `};

  ${({ $isComplete, theme }) =>
    $isComplete &&
    css`
      color: ${theme.palette.success.main};
    `};

  ${({ $isSuccess, theme }) =>
    $isSuccess &&
    css`
      ${typographyToCss(theme.typography.subtitle2)};
      color: ${theme.palette.success.main};
    `};
`;
